import { useEffect } from "react";
import { Field } from "./Field";
import SignaturePad from "./SignaturePad";

function todayMMDDYYYY() {
    const d = new Date();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${m}/${day}/${d.getFullYear()}`;
}
function toISODate(mmddyyyy) {
    const m = (mmddyyyy || "").match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (!m) return "";
    return `${m[3]}-${m[1]}-${m[2]}`;
}
function fromISO(iso) {
    const m = (iso || "").match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return "";
    return `${m[2]}/${m[3]}/${m[1]}`;
}

export function validateFinalize(p, { dev = false } = {}) {
    const errs = {};
    if (dev) return errs;
    if (!p?.signature) errs.signature = "Signature is required";
    if (!p?.date) errs.date = "Date is required";
    if (!p?.confirm) errs.confirm = "You must confirm to submit";
    return errs;
}

export default function StepFinalize({ value, onChange, errors = {} }) {
    const v = value || {};
    const set = (k, val) => onChange({ ...v, [k]: val });

    useEffect(() => {
        if (!v.date) set("date", todayMMDDYYYY());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="space-y-7" data-testid="step-finalize">
            <div>
                <div className="step-eyebrow">STEP 6</div>
                <h2 className="font-display text-3xl sm:text-4xl text-white mt-2">That's it — you made it.</h2>
                <p className="mt-3 text-sm text-white/70 leading-relaxed">
                    We'll take it from here and keep everything moving behind the scenes. Take a moment to review your information, then sign below and submit. If we need anything else, we'll reach out within 24–48 hours.
                </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-[1fr_220px] gap-5 items-start">
                <Field label="Signature" error={errors.signature} testId="field-signature">
                    <SignaturePad value={v.signature} onChange={(d) => set("signature", d)} />
                </Field>
                <Field label="Date" error={errors.date} testId="field-date">
                    <input
                        type="date"
                        value={toISODate(v.date) || ""}
                        onChange={(e) => set("date", fromISO(e.target.value))}
                        className="glow-input w-full px-4 py-3 rounded-xl text-sm uppercase tracking-wide gold-text"
                        data-testid="input-date"
                    />
                </Field>
            </div>

            <button
                type="button"
                onClick={() => set("confirm", !v.confirm)}
                className="w-full text-left flex items-start gap-3 group"
                data-testid="confirm-radio"
            >
                <span className={`radio-chip mt-0.5 ${v.confirm ? "checked" : ""}`} />
                <span className="text-sm text-white/85 group-hover:text-white transition">
                    I confirm all information is accurate and authorize the process.
                </span>
                {errors.confirm && <span className="ml-auto text-xs text-red-400">{errors.confirm}</span>}
            </button>
        </div>
    );
}
